// production
export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyBlrQnlwBK6r5kwmesPkz693V3eHPTMTLI",
    authDomain: "integral-production-2379f.firebaseapp.com",
    projectId: "integral-production-2379f",
    storageBucket: "integral-production-2379f.firebasestorage.app",
    messagingSenderId: "397589092064",
    appId: "1:397589092064:web:b7fdaf16346b40bd49e285",
    measurementId: "G-G6L1R09YKG"
  },
  getDocumentStorage: "https://us-central1-integral-production-2379f.cloudfunctions.net/getDocumentStorage",
  getDashboardUrl: "https://us-central1-integral-production-2379f.cloudfunctions.net/getDashboardUrl",

  forgotPasswordFunction: "https://us-central1-integral-production-2379f.cloudfunctions.net/forgotPassword"

};

//------------------------------------------------------------------------------------------------------------------------------------//

// developer
// export const environment = {
//   production: true,
//   firebaseConfig: {
//     apiKey: "AIzaSyA8J7BxBrY4AMamWNWII_mddK41MFS-sJ4",
//     authDomain: "integral-developer.firebaseapp.com",
//     projectId: "integral-developer",
//     storageBucket: "integral-developer.appspot.com",
//     messagingSenderId: "206987014639",
//     appId: "1:206987014639:web:c39bb433eade145c90861a",
//     measurementId: "G-26T1YL9FZM"
//   },
//   getDocumentStorage: "https://us-central1-integral-developer.cloudfunctions.net/getDocumentStorage",
//   dashboardInspectionCompanyKey: "https://lookerstudio.google.com/embed/reporting/fb534b9e-ad70-4516-be4a-5e05fdd415b2/page/xqApD",
//   dashboardAbsenteeismCompanyKey: "https://lookerstudio.google.com/embed/reporting/c5c9d3c4-7031-437c-9d2e-aa590d51ce68/page/xqApD",
//   dashboardContinuousImprovementCompanyKey: "https://lookerstudio.google.com/embed/reporting/26330b12-59bd-4fc3-8436-cd61800e1d45/page/xqApD",
// };